var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendButtonColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0_1303_1288)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1303_1288",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1303_1288",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1303_1288",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA7dJREFUeAHtnTGI1EAUhk8QUSwsbK1stLG0OktbS1uxsrW0tRFsLW0tbS0trhFBTCassIXF3RWZyUwsBEGQKySSvR2SBS95yWY38+b9B8ct7Nsw8307k/kn2b2DA/yAAAiAAAiAAAiAAAiAAAiAAAiAAAiAAAiAQCQESpMdOre4Hkl3+HejLNR7m6tfzqg3Wi9u8e8R8x7UQpxR1flverYSZLP7zLvFt/mbQrwYVTmtPjmTPqqq6hLf3jFs+YVC1qPGmuS7K7Lnp6dHVxl2j1+T+4T46cxq5axJX2r95Sa/XjJqMVWIF+OM+mO1elcUyV1G3eTT1BFCVgsAq9O/zmQfSqMe8uktg5aOFdIaMZXLVVJq9aSqji4z6HLYTZxEiF8258mJNerFz+PkRti9Drh1kwrxKzMEzfHGdyGkmc4QNAeb2a0QBM1whfjpDEGz29HeRog/8XsxCJr/FzOXkOY8g6C5YSYAIQiabSOhCGmNGNlBM0gh/nwjMWgGLcQvACQFTQ5CmulMQNDkJURA0GQrxE9nsQVN7kL8dBbNFc1YhHgx7K9oRiiEd9CMVUhrxPAKmiKEcAqaooT4lVnIQVOikGY6CzBoyhYSYNAsdPrK6uy4Xi4275xWQ/38K+SvNeqb1dnT5XJ5pb0rPsvjPP98rSy/3v5RJA+szh7X9/SWRr1e3alo0o8uT5frjy6s75aPVxyroClMXDy3zsYkTtSts+zE4dbZ81NqcOIkXtEcs7rZtzh8RrPHEoT0AJrq6X2D7s1leXJSR4PoPlYeHOi+EMz1pM4OdIeIZtmbHU414ic7Tkyge6clnf52OntrzOLOZACpBxIFumM01JJm2zrB5uLmftzsm4vYfl8LCeWbK2QLSc/qnWyXJ/eo0/rO6yQKCTpZixLCIciJEMIpyMUqJOgg13Uiik7InEGuCzT1uViEzBbkqKCpddyFWKMWrkifRfMFa2yFhBLkqO98ah0vIQEGOSpoah0HIUEHOSpoal3QQjgEOSpoal2QQjgFOSpoal0oQtgGOSpoat3sQrgHOSpoat1cQqIJclTQ1Lp9C4kuyFFBU+v2JiTWIEcFTa3brRABQY4Kmlq3CyGighwVNLVuUiESgxwVNLVuEiGSgxwVNLVurBAEOSrhgXWDhSDIDSQ8sJwqBEFuINix5X1CEOTGkh35uguFIMiNJLrlyzaFIMhtiXP7l9dCEOS25zjZEfCvVydDiQOBAAiAAAiAAAiAAAiAAAiAAAiAAAiAAAiAQFQE/gGAIH9ir4MUewAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButtonColor);
export default __webpack_public_path__ + "static/media/sendButtonColor.0f1b8937e305b25fb14e27ce681b1a7b.svg";
export { ForwardRef as ReactComponent };